import React from 'react'
import { Box, Typography, Stack} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import logo_LV from "../assets/logo_LV.gif"


const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Stack spacing={2} alignItems= 'center' direction="row" sx={{mt: 5}}>
      <Box component="img" alt="Your logo."  src={logo_LV} sx={{width:30, heigth: 30}}></Box>
      {isMobile ? <Typography/> : <Typography style={{fontWeight: 'bold'}}>©2023</Typography>}
      {isMobile ? <Typography/> : <Typography style={{color: "#971A3B", fontWeight: 'bold'}}>Luc Vets Diamonds</Typography>}
      {isMobile ? <Typography/> : <Typography  style={{color: "#565656", textAlign: 'left', fontSize:'12px'}}>Antwerp, Belgium</Typography>}
      <Typography  style={{color: "#565656", textAlign: 'left', fontSize:'12px'}}>tel: +32-3-233.8887</Typography>
      <Typography  style={{color: "#565656", textAlign: 'left', fontSize:'12px'}}>info@lvdiamonds.net</Typography>
    </Stack>
  )
}

export default Footer
